import Badge from 'components/Badge';

const RedeliveredLabel = ({ value }: { value: string; }) => <Badge label={value} size="medium" />;

export default RedeliveredLabel;
